import { Image, } from 'grommet';
import styled from 'styled-components';
const StyledLogoImage = styled(Image) `
  max-height: 80px;
  max-width: 80%;
`;
export default StyledLogoImage;
